import React, { useCallback, useEffect, useState } from "react";
import { FadeAccordion, FadeAccordionItem, LinkButton } from "../Global/Transitions";
import { Accordion } from "react-bootstrap";
import MemberDto from "../../Models/MemberDto";
import { USERS_COLORS } from "../../Utilities/UsersColors";
import { LoaderIcon, TestCountIcon } from "../Global/Icons";
import { useMsal } from "@azure/msal-react";
import { useApiErrorHandler } from "../../Utilities/useApiErrorHandler";
import { getProjectUsers } from "../../Services/AccessControlService";

interface UsersWidgetProps {
  isdisable?: boolean;
  id?: number;
}


const UsersWidget: React.FC<UsersWidgetProps> = ({ isdisable = false, id }) => {
  const { instance, accounts } = useMsal();
  const [members, setMembers] = useState<MemberDto[]>([]);
  const [loading, setLoading] = useState(false);
  const [, setFetchError] = useState(false);
  const { handleApiError } = useApiErrorHandler();

  const fetchUsers = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      const returnedmembers = await getProjectUsers(instance, accounts?.[0], id);
      setMembers(returnedmembers);
    } catch (err: any) {
      handleApiError(err);
      setFetchError(true);
    } finally {
      setLoading(false);
      
    }
  }, [instance, accounts, handleApiError, id]);

  useEffect(() => {
    void fetchUsers();
  }, [fetchUsers]);



  const users = React.useMemo(() => {
    let managers = 0;
    let viewers = 0;
    members.forEach((u) => {
      const roles = u.applicationRole ?? [];
      if (roles.some((r) => r.userRole.toLowerCase() === "project manager")) managers++;
      if (roles.some((r) => r.userRole.toLowerCase() === "project viewer")) viewers++;
    });
    return {
      total: members.length,
      managers,
      viewers
    };
  }, [members]);


  const roleBadgeClass = (role: string) => {
    // console.log(fetchError);
    const key = role.trim().toLowerCase();
    return USERS_COLORS[key] ?? "role-default";
  };

  return (
    <FadeAccordion defaultActiveKey="0">
      <FadeAccordionItem small eventKey={isdisable ? '1' : '0'}>
        <Accordion.Button as="h3">
          Project Users
          <TestCountIcon number={users.total} className={'ms-2 ' + (users.total > 0 ? 'text-secondary' : 'text-gray')} />
        </Accordion.Button>
        {loading ? <LoaderIcon /> : (
          <Accordion.Body>
            {members.length === 0 ? (
              <p>No users assigned.</p>
            ) : (
              <div className="d-flex flex-column gap-3">
                {members.map((u) => {
                  const roles = u.applicationRole?.map((r) => r.userRole) ?? [];

                  return (

                    <div key={u.id} className="d-flex align-items-center justify-content-between border-bottom pb-3">
                      <div className="d-flex align-items-center gap-3">
                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 240 }}>
                            {u.displayName}
                          </div>
                          <div style={{ fontSize: 12, color: "#6c757d", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 240 }}>
                            {u.email}
                          </div>
                        </div>
                      </div>

                      {/* roles */}
                      <div className="d-flex gap-2" style={{ minWidth: 120, justifyContent: "flex-end" }}>
                        {roles.length === 0 ? (
                          <span className="text-muted" style={{ fontSize: 12 }}>
                            No roles
                          </span>
                        ) : (
                          roles.map((r) => (
                            <span
                              key={r}
                              className={"px-2 py-1 " + roleBadgeClass(r)}
                              style={{ fontSize: 12, fontWeight: 600 }}
                            >
                              {r}
                            </span>
                          ))
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <LinkButton className="mt-4" to={'/usermanagement'}>Manage Users</LinkButton>
          </Accordion.Body>
        )}
      </FadeAccordionItem>
    </FadeAccordion>
  );
};

export default UsersWidget;
